import { Link } from 'react-router-dom'
import logo from '../../assets/logo.png'

function HeaderLogo() {
  return (
    <Link className="header-logo" to='/welcome'>
      <img id='welcome' src={logo} alt="Pillot Games"/>
    </Link>
  )
}

export default HeaderLogo